import { UseQueryOptions } from '@tanstack/react-query';

import { mapBrandProfileFromApi } from 'domains/brand/mapBrandProfileFromApi';
import { BrandProfileField, BrandProfileFieldApi } from 'domains/brand/types';
import useQuery from 'hooks/useQuery';
import { CuredApiPaths } from 'models/enums';

import QueryKeys from './keys';

export type UseBrandProfileOptions = Omit<
    UseQueryOptions<BrandProfileFieldApi[], Error, BrandProfileField[]>,
    'queryKey' | 'queryFn' | 'select'
>;

const useBrandProfile = (reactQueryOptions?: UseBrandProfileOptions) =>
    useQuery<BrandProfileFieldApi[], BrandProfileField[]>(QueryKeys.BRAND_PROFILE, CuredApiPaths.BRAND_PROFILE, {
        ...reactQueryOptions,
        select: (data) => mapBrandProfileFromApi(data),
    });

export default useBrandProfile;
